var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBookedIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 11.7539C8.75 11.7539 11 9.50391 11 6.75391C11 4.00391 8.75 1.75391 6 1.75391C3.25 1.75391 1 4.00391 1 6.75391C1 9.50391 3.25 11.7539 6 11.7539Z",
    stroke: "#7CCA62",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.875 6.75387L5.29 8.16887L8.125 5.33887",
    stroke: "#7CCA62",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookedIcon);
export default __webpack_public_path__ + "static/media/bookedIcon.d7784292bbacc020f072a52962615bdb.svg";
export { ForwardRef as ReactComponent };